/* Cœura chain upsell — a pendant or a locket arrives without a chain, so the moment one goes into the
   cart this asks the one question the customer would otherwise discover at home: what carries it.
   Opens over the cart drawer (the drawer stays behind, and is what they return to), lists every
   available carrier in the metal they just chose, and adds one in a single click with its length.
   Opened by pdp.js after a successful add; data comes from window.__PDP.chains (Liquid, live prices). */
(function () {
  'use strict';
  var METAL_LABEL = { silver: 'Sterling Silver', vermeil: '18K Gold Vermeil', mixed: 'Mixed Metals' };
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  var cfg = null, lastFocus = null;

  /* Option values in catalogue order, deduped — Length reads 16-18", 20-22", 26-30" as merchandised. */
  function valuesOf(chain, idx) {
    var seen = {}, out = [];
    chain.variants.forEach(function (v) {
      var val = v.opts[idx];
      if (val == null || seen[val]) return;
      seen[val] = 1; out.push(val);
    });
    return out;
  }
  function optIndex(chain, name) {
    for (var i = 0; i < (chain.options || []).length; i++) if (chain.options[i] === name) return i;
    return -1;
  }
  /* the metal the customer just chose, if this carrier is made in it; else the one it is made in */
  function metalFor(chain, li, mi) {
    if (mi < 0) return null;
    var want = METAL_LABEL[cfg.metal === 'mixed' ? 'silver' : cfg.metal];
    var vals = valuesOf(chain, mi);
    return vals.indexOf(want) !== -1 ? want : vals[0];
  }
  function variantFor(chain, sel) {
    var match = chain.variants.filter(function (v) {
      return Object.keys(sel).every(function (i) { return v.opts[i] === sel[i]; });
    });
    return match.filter(function (v) { return v.avail; })[0] || match[0] || null;
  }

  function card(chain) {
    var li = optIndex(chain, 'Length'), mi = optIndex(chain, 'Metal');
    var sel = {};
    if (mi >= 0) sel[mi] = metalFor(chain, li, mi);
    if (li >= 0) {
      var lens = valuesOf(chain, li).filter(function (L) {
        var t = {}; t[li] = L; if (mi >= 0) t[mi] = sel[mi];
        var v = variantFor(chain, t); return v && v.avail;
      });
      sel[li] = lens[0] || valuesOf(chain, li)[0];
    }

    var c = el('div', 'cgu-card');
    var shot = el('a', 'cgu-shot'); shot.href = chain.url;
    var img = new Image(); img.className = 'cgu-plate'; img.decoding = 'async'; img.alt = '';
    shot.appendChild(img); c.appendChild(shot);

    var meta = el('div', 'cgu-meta');
    meta.appendChild(el('span', 'cgu-name', esc(chain.title)));
    var price = el('span', 'cgu-price', ''); meta.appendChild(price);
    c.appendChild(meta);

    var opts = el('div', 'cgc-opts');
    function selectFor(idx, label) {
      if (idx < 0) return null;
      var vals = valuesOf(chain, idx);
      if (vals.length < 2) return null;                 // one value is not a choice; it is the piece
      var wrap = el('label', 'cgc-opt');
      wrap.appendChild(el('span', 'cgc-opt__k', esc(label)));
      var s = document.createElement('select');
      s.className = 'cgc-opt__s';
      s.setAttribute('aria-label', label + ' — ' + chain.title);
      vals.forEach(function (val) {
        var o = document.createElement('option'); o.value = val; o.textContent = val;
        if (val === sel[idx]) o.selected = true;
        s.appendChild(o);
      });
      s.addEventListener('change', function () { sel[idx] = s.value; sync(); });
      wrap.appendChild(s);
      opts.appendChild(wrap);
      return s;
    }
    selectFor(li, 'Length');
    selectFor(mi, 'Metal');
    if (opts.childNodes.length) c.appendChild(opts);

    var acts = el('div', 'cgu-acts');
    var add = el('button', 'cgu-btn cgu-btn--add', 'Add to cart'); add.type = 'button';
    var view = el('a', 'cgu-btn cgu-btn--view', 'View product'); view.href = chain.url;
    acts.appendChild(add); acts.appendChild(view); c.appendChild(acts);

    /* image, price and the button all follow the current selection — the customer sees the chain
       they are actually buying, in the metal they picked, before they commit */
    function sync() {
      var v = variantFor(chain, sel);
      img.src = (v && v.image) || chain.image || '';
      price.textContent = v ? v.priceText : '';
      view.href = chain.url + (v ? '?variant=' + v.id : '');
      if (!v || !v.avail) { add.disabled = true; add.textContent = 'Sold out'; }
      else if (!add.classList.contains('is-added')) { add.disabled = false; add.textContent = 'Add to cart'; }
      return v;
    }
    add.addEventListener('click', function () {
      var v = variantFor(chain, sel);
      if (!v || !v.avail) return;
      add.disabled = true; add.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: 1, properties: { _With: cfg.pieceTitle || '' } })
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          add.textContent = 'Added ✓'; add.classList.add('is-added');
          if (cfg.onAdded) cfg.onAdded();
        })
        .catch(function () { add.disabled = false; add.textContent = 'Add to cart'; location.href = view.href; });
    });
    sync();
    return c;
  }

  function onKey(e) { if (e.key === 'Escape') close(); }
  function close() {
    var m = document.getElementById('cgc-modal');
    if (m) m.remove();
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function open(opts) {
    opts = opts || {};
    var chains = (opts.chains || []).filter(function (c) {
      return c && c.variants && c.variants.some(function (v) { return v.avail; });
    });
    if (!chains.length) return false;
    cfg = { metal: opts.metal || 'vermeil', pieceTitle: opts.pieceTitle || '', onAdded: opts.onAdded };

    close();
    lastFocus = document.activeElement;
    var overlay = el('div', 'cgu-modal cgc-modal');
    overlay.id = 'cgc-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Add a chain');

    var box = el('div', 'cgu-box');
    var head = el('div', 'cgu-head');
    head.appendChild(el('span', 'cgu-eyebrow', 'In your cart'));
    head.appendChild(el('h2', 'cgu-title', 'Want to add a chain?'));
    head.appendChild(el('p', 'cgu-sub', (opts.pieceTitle ? esc(opts.pieceTitle) : 'Your piece') +
      ' hangs on any of these. Choose a length; the metal follows what you chose.'));
    var x = el('button', 'cgu-x', '&times;'); x.type = 'button'; x.setAttribute('aria-label', 'Close');
    x.addEventListener('click', close); head.appendChild(x);
    box.appendChild(head);

    var grid = el('div', 'cgu-grid');
    chains.forEach(function (c) { grid.appendChild(card(c)); });
    box.appendChild(grid);

    var foot = el('div', 'cgu-foot');
    var no = el('button', 'cgu-btn cgu-btn--ghost', 'No thanks'); no.type = 'button';
    no.addEventListener('click', close);
    var done = el('button', 'cgu-btn cgu-btn--primary', 'Back to cart'); done.type = 'button';
    done.addEventListener('click', close);
    foot.appendChild(no); foot.appendChild(done);
    box.appendChild(foot);

    overlay.appendChild(box);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.body.appendChild(overlay);
    document.addEventListener('keydown', onKey);
    x.focus();
    return true;
  }

  window.CoeuraChain = { open: open, close: close };
})();
